module.exports = __webpack_public_path__ + "img/minus_btn.bb0bf27d.png";